
export default {
  inheritAttrs: false,

  props: {
    color: {
      type: String,
      default: 'secondary',
    },
    elevation: {
      type: [Number, String],
      default: 10,
    },
    inline: {
      type: Boolean,
      default: false,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    offset: {
      type: [Number, String],
      default: 24,
    },
    title: {
      type: String,
      default: undefined,
    },
    text: {
      type: String,
      default: undefined,
    },
  },

  computed: {
    hasOffset() {
      return (this as any).$slots.header ||
        (this as any).$slots.offset ||
        (this as any).title ||
        (this as any).text;
    },
    styles() {
      if (!this.hasOffset) { return null; }

      return {
        marginBottom: `${(this as any).offset}px`,
        marginTop: `${(this as any).offset * 2}px`,
      };
    },
  },
};
